module.exports = "/_next/static/images/takeout_100_top-bc74032949b6f043ef26bab21a2a1639.jpg";